// Test IDs for the Hospice Education Blog
export const NAV = {
  logo: "nav-logo",
  home: "nav-home",
  pathways: "nav-pathways",
  bookmarks: "nav-bookmarks",
  admin: "nav-admin",
  login: "nav-login-btn",
  userMenu: "nav-user-menu",
  logout: "nav-logout-btn",
  searchInput: "nav-search-input",
  searchSubmit: "nav-search-submit",
  moduleFilter: "nav-module-filter",
  themeMenu: "nav-theme-menu",
  themeLight: "nav-theme-light",
  themeDark: "nav-theme-dark",
  themeSystem: "nav-theme-system",
};

export const HOME_P = {
  hero: "home-hero",
  ctaLogin: "home-cta-login",
  moduleCard: (id) => `module-card-${id}`,
  pathwayCard: (id) => `pathway-card-${id}`,
};

export const BLOG = {
  reader: "blog-reader",
  title: "blog-title",
  tocDesktop: "blog-toc-desktop",
  tocMobile: "blog-toc-mobile",
  tocLink: (id) => `blog-toc-link-${id}`,
  bookmark: "blog-bookmark-btn",
};

export const PATHWAY = {
  view: "pathway-view",
  bookmark: "pathway-bookmark-btn",
  blogLink: (id) => `pathway-blog-${id}`,
};

export const ADMIN = {
  dashboard: "admin-dashboard",
  tabUpload: "admin-tab-upload",
  tabPathways: "admin-tab-pathways",
  tabGlossary: "admin-tab-glossary",
  tabUsers: "admin-tab-users",
  tabAnalytics: "admin-tab-analytics",
  uploadForm: "admin-upload-form",
  uploadFile: "admin-upload-file",
  uploadSubmit: "admin-upload-submit",
  createPathwayForm: "admin-create-pathway-form",
  pathwayTitle: "admin-pathway-title",
  pathwayDescription: "admin-pathway-description",
  pathwayBlogToggle: (id) => `admin-pathway-blog-toggle-${id}`,
  pathwaySubmit: "admin-pathway-submit",
  // Glossary
  glossaryTerm: "admin-glossary-term",
  glossaryDefinition: "admin-glossary-definition",
  glossaryAliases: "admin-glossary-aliases",
  glossarySubmit: "admin-glossary-submit",
  // Users
  userRoleSelect: (id) => `admin-user-role-${id}`,
};

export const GLOSSARY = {
  page: "glossary-page",
  item: (id) => `glossary-item-${id}`,
};

export const PROFILE = {
  page: "profile-page",
};

export const COMMENTS = {
  form: "comment-form",
  input: "comment-input",
  submit: "comment-submit",
  item: (id) => `comment-item-${id}`,
  delete: (id) => `comment-delete-${id}`,
};

export const SEARCH = {
  page: "search-page",
  result: (id) => `search-result-${id}`,
};
